import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { components } from "../components";
import AppStepper from "../components/apps/AppStepper";
import { AppState, dispatch, useSelector } from "../store/store";
import { profileActions } from "../store/slices/profileSlice";
import EmailVerificationStep from "../components/profile/steps/EmailVerificationStep";
import PersonalDataStep from "../components/profile/steps/PersonalDataStep";
import IdentityVerificationStep from "../components/profile/steps/IdentityVerificationStep";
import AuthLayout from "../services/auth/jwt/withAuth";
import { setScreen } from "../store/slices/tabSlice";
import { TABS } from "../constants/app_routes";

export const VerificationScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { steps, currentStep } = useSelector<AppState["profile"]>(
    ({ profile }) => profile
  );
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderHeader = (): JSX.Element => {
    return <components.Header goBack={true} />;
  };

  const onClickStep = (step: number) => {
    dispatch(profileActions.onClickStep(step));
  };
  const backToProfile = () => {
    navigate(-1);
    dispatch(setScreen(TABS.PROFILE));
  };

  const renderSteps = (currentStep: number): JSX.Element => {
    return (
      <div className="verification">
        {currentStep === 1 && (
          <EmailVerificationStep backToProfile={backToProfile} />
        )}
        {currentStep === 2 && <PersonalDataStep />}
        {currentStep === 3 && (
          <IdentityVerificationStep backToProfile={backToProfile} />
        )}
      </div>
    );
  };

  return (
    <AuthLayout>
      {renderHeader()}
      <main
        className="container"
        style={{ paddingTop: "20%", paddingBottom: 20 }}
      >
        <Typography sx={{ textAlign: "center" }}>
          {t("accountVerification")}
        </Typography>
        <Divider sx={{ m: 2 }} />
        <AppStepper
          currentStep={currentStep}
          steps={steps}
          onClick={onClickStep}
        />
        {renderSteps(currentStep)}
      </main>
    </AuthLayout>
  );
};
